import { Button, ButtonGroup, Tooltip } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { AxiosError } from 'axios';
import ConditionalTooltip from 'components/ConditionalTooltip';
import {
  CartMember,
  getAvailabilityThunk,
  removeCart,
  setSelected,
} from 'features/shoppingCart/shoppingCartSlice';
import { useThunkDispatch } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  cartId: number;
  numCarts: number;
  cartMembers: CartMember[];
  handleAvailabilityError: (error: AxiosError) => void;
}

export default ({ cartId, numCarts, cartMembers, handleAvailabilityError }: Readonly<Props>) => {
  const { t } = useTranslation(['common', 'cart']);

  const dispatch = useThunkDispatch();

  const fetchAvailability = () => {
    cartMembers.forEach((member) => {
      dispatch(getAvailabilityThunk(cartId, member.id, member.smiles)).catch(
        handleAvailabilityError,
      );
    });
  };

  const setAllSelected = (selected: boolean) => () => {
    cartMembers.forEach((cartMember) => {
      cartMember.availability?.forEach((item) => {
        dispatch(setSelected({ cartId, cartMember: cartMember.id, item, selected: selected }));
      });
    });
  };

  return (
    <>
      <ButtonGroup aria-label="small contained button group">
        <Tooltip arrow title={t('cart:fetch_all')!}>
          <Button variant="outlined" color="default" onClick={fetchAvailability}>
            <GetAppIcon />
          </Button>
        </Tooltip>
        <Tooltip arrow title={t('cart:add_all_to_list')!}>
          <Button variant="outlined" color="default" onClick={setAllSelected(true)}>
            <AddCircleOutlineIcon />
          </Button>
        </Tooltip>
        <Tooltip arrow title={t('cart:remove_all_from_list')!}>
          <Button variant="outlined" color="default" onClick={setAllSelected(false)}>
            <RemoveCircleOutlineIcon />
          </Button>
        </Tooltip>
        <ConditionalTooltip condition={!(numCarts <= 1)} title={t('cart:delete_cart')!}>
          <Button
            disabled={numCarts <= 1}
            variant="outlined"
            color="secondary"
            onClick={() => dispatch(removeCart(cartId))}
          >
            <DeleteIcon />
          </Button>
        </ConditionalTooltip>
      </ButtonGroup>
    </>
  );
};
